import React from 'react';
import type { HighlightedProps, SchoolReportType } from '../../types';
import type { TopicChartType } from '../../../mapper/groupTopicReportMapper';
import {
  MathsAgeDelta,
  SchoolMathsAgeImprovements,
  SchoolProgressions,
  SchoolQualityLearningTime,
  SchoolTopicProgress,
} from '../sections';
import InitialAssessmentCompleted from '../sections/InitialAssessmentCompleted';
import type { ChartIconType } from '../../../components/charts/types';
import type { DateRange } from '../../../util/types';

type Props = {
  schoolReport: SchoolReportType;
  chartTopicProgress: TopicChartType[];
  filterLabel: string | null;
  filteredIds: number[] | null;
  showOthersData: boolean;
  iconToUse: ChartIconType;
  dateRange?: DateRange;
} & Pick<HighlightedProps, 'onElementClick'>;

const SchoolChartsView = ({
  schoolReport,
  chartTopicProgress,
  filterLabel,
  filteredIds,
  showOthersData,
  iconToUse,
  dateRange,
  onElementClick,
}: Props): JSX.Element => {

  const filteredHighlightedIds = filteredIds || [];

  return (
    <>
      {/* Maths Age Delta*/}
      <MathsAgeDelta
        schoolReport={schoolReport}
        highlightedLabel={filterLabel}
        highlightedIds={filteredHighlightedIds}
        iconToUse={iconToUse}
        showOthersData={showOthersData}
        onElementClick={onElementClick}
      />
      {/* Maths Age Improvements */}
      <SchoolMathsAgeImprovements
        schoolReport={schoolReport}
        highlightedIds={filteredHighlightedIds}
        highlightedLabel={filterLabel}
        iconToUse={iconToUse}
        showOthersData={showOthersData}
        dateRange={dateRange}
        onElementClick={onElementClick}
      />
      {/* Progressions */}
      <SchoolProgressions
        schoolReport={schoolReport}
        highlightedIds={filteredHighlightedIds}
        highlightedLabel={filterLabel}
        iconToUse={iconToUse}
        showOthersData={showOthersData}
        onElementClick={onElementClick}
      />
      {/* Quality Learning Time */}
      <SchoolQualityLearningTime
        schoolReport={schoolReport}
        highlightedIds={filteredHighlightedIds}
        highlightedLabel={filterLabel}
        iconToUse={iconToUse}
        showOthersData={showOthersData}
        onElementClick={onElementClick}
      />
      {/* Initial Assessment Completed */}
      <InitialAssessmentCompleted
        schoolReport={schoolReport}
        highlightedLabel={filterLabel}
        highlightedIds={filteredHighlightedIds}
        iconToUse={iconToUse}
        showOthersData={showOthersData}
        onElementClick={onElementClick}
      />
      {/* Topic Progress */}
      <SchoolTopicProgress
        chartTopicProgress={chartTopicProgress}
        iconToUse={iconToUse}
        showOthersData={showOthersData}
        highlightedLabel={filterLabel}
        highlightedIds={filteredHighlightedIds}
      />
    </>
  );
};

SchoolChartsView.displayName = 'SchoolChartsView';

export default SchoolChartsView;
